
export default function AboutStory() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/ee9ed00f5f9369a5164ffd95d478153e.jpg"
                alt="Bureau COBRA SECURITE avec logo" 
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-red-600 text-white p-6 rounded-2xl shadow-xl">
                <div className="text-3xl font-bold">25 ans</div>
                <div className="text-sm">d'expertise</div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              Notre <span className="text-red-600">Histoire</span>
            </h2>
            
            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p className="text-lg">
                Fondée en <strong className="text-gray-900">1999</strong>, COBRA SECURITE s'est imposée comme un acteur incontournable dans le domaine de la sécurité en Tunisie. Depuis 25 années, nous accompagnons nos clients dans la protection de leurs biens et de leurs personnes grâce à des solutions technologiques de pointe et un service client d'exception.
              </p>
              
              <p className="text-lg">
                Notre parcours a été marqué par une croissance constante et une adaptation permanente aux évolutions technologiques du secteur. De nos premiers systèmes d'alarme aux solutions connectées d'aujourd'hui, nous avons toujours privilégié l'innovation et la qualité pour répondre aux besoins croissants de sécurité de nos clients.
              </p>
              
              <p className="text-lg">
                Aujourd'hui, forte de son expérience et de son expertise reconnue, COBRA SECURITE continue d'évoluer pour offrir des solutions de sécurité toujours plus performantes et adaptées aux défis de demain. Notre engagement reste le même : protéger ce qui compte le plus pour vous.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="text-center p-4 bg-gray-50 rounded-xl">
                <div className="text-2xl font-bold text-red-600 mb-2">2500+</div>
                <div className="text-sm text-gray-600">Clients de confiance</div>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-xl">
                <div className="text-2xl font-bold text-red-600 mb-2">99.8%</div>
                <div className="text-sm text-gray-600">Satisfaction client</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
